<template>
  <div class="text-[#0b105d]">
    <div
      class="flex flex-col min-h-screen bg-gradient-to-br from-[#f4f4f4] via-[#f8f9fa] to-[#e9ecef]"
    >
      <Navbar />
      <main class="flex-grow">
        <router-view v-slot="{ Component, route }">
          <transition name="page" mode="out-in">
            <component :is="Component" :key="route.path" />
          </transition>
        </router-view>
      </main>
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import Footer from '@/components/layout/Footer.vue'
import Navbar from '@/components/layout/Navbar.vue'
</script>

<style>
* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  scroll-padding-top: 100px;
}

body {
  font-family:
    'Plus Jakarta Sans',
    'Inter',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.page-enter-active {
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.page-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px) scale(0.98);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(1.02);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, #fe6d0d, #ffb47c);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(to bottom, #ffb47c, #fe6d0d);
}

::selection {
  background: rgba(254, 109, 13, 0.25);
  color: #0b105d;
}

::-moz-selection {
  background: rgba(254, 109, 13, 0.25);
  color: #0b105d;
}

*:focus-visible {
  outline: 2px solid #fe6d0d;
  outline-offset: 2px;
  border-radius: 2px;
}

*:focus:not(:focus-visible) {
  outline: none;
}

.text-responsive-xs {
  font-size: clamp(0.75rem, 2vw, 0.875rem);
} /* ~12px to 14px */
.text-responsive-sm {
  font-size: clamp(0.875rem, 2.5vw, 1rem);
} /* ~14px to 16px */
.text-responsive-base {
  font-size: clamp(1rem, 3vw, 1.125rem);
} /* ~16px to 18px */
.text-responsive-lg {
  font-size: clamp(1.125rem, 3.5vw, 1.25rem);
} /* ~18px to 20px */
.text-responsive-xl {
  font-size: clamp(1.25rem, 4vw, 1.5rem);
} /* ~20px to 24px */
.text-responsive-2xl {
  font-size: clamp(1.5rem, 5vw, 2rem);
} /* ~24px to 32px */
.text-responsive-3xl {
  font-size: clamp(1.875rem, 6vw, 3rem);
} /* ~30px to 48px */

@media print {
  .no-print {
    display: none !important;
  }
  body {
    background: #fff !important;
    color: #000 !important;
  }
}
</style>
